import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import "core-js/modules/es.function.name.js";
import { h } from "@vue/composition-api";
import { defineComponent } from 'vue-demi';
import { RingProgress } from '@antv/g2plot';
import BaseChart from '../../components/base';
import { mergeAttrs } from '../../utils';
var RingProgressChart = defineComponent({
  name: 'RingProgressChart',
  setup: function setup(props, ctx) {
    return function () {
      return h(BaseChart, _mergeJSXProps([{
        "attrs": {
          "chart": RingProgress
        }
      }, mergeAttrs(props, ctx.attrs)]));
    };
  }
});
/* istanbul ignore next */

RingProgressChart.install = function (app) {
  app.component(RingProgressChart.name, RingProgressChart);
};

export default RingProgressChart;